import { createSelector } from 'reselect';

import * as TableBasedInventory from 'types/tableBasedInventory';
import { groupBy } from 'es-toolkit/compat';
import detailedSquaresByDateTimeSelector from 'selectors/routes/calendar/detailedCalendarSquaresSelector';

export interface CalendarSquaresByTable {
  [tableId: string]: TableBasedInventory.NormalDetailedSquare[];
}

function computeCalendarSquaresByTable(
  allCalendarSquares: TableBasedInventory.NormalDetailedSquare[]
): CalendarSquaresByTable {
  return groupBy(allCalendarSquares, (calendarSquare) => calendarSquare.tableId);
}

export const calendarSquaresByTableSelector = createSelector(
  detailedSquaresByDateTimeSelector,
  computeCalendarSquaresByTable
);
